import { PaginationResponse } from "models/pagination-response";
import { IContratoPagedRequest } from "models/request/contrato-paged-request";
import { IContratoPagedResponse } from "models/response/contrato-paged-response";
import { ITipoContratoResponse } from "models/response/tipo-contrato-response";
import { ISituacaoContratoResponse } from "models/response/situacao-contrato-response";

export type ContratosState = {
    contratos: PaginationResponse<IContratoPagedResponse>;
    contratoPagedRequest: IContratoPagedRequest;
    tipos: ITipoContratoResponse[];
    situacoes: ISituacaoContratoResponse[];
    ultimaAtualizacao: string | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setContratos = 'setContratos',
    setContratoPagedRequest = 'setContratoPagedRequest',
    setTipos = 'setTipos',
    setSituacoes = 'setSituacoes',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const ContratosReducer = (state: ContratosState, action: any): ContratosState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setContratoPagedRequest:
            return { ...state, contratoPagedRequest: payload };
        case ACTION_TYPES.setContratos:
            return { ...state, contratos: payload };
        case ACTION_TYPES.setTipos:
            return { ...state, tipos: payload };
        case ACTION_TYPES.setSituacoes:
            return { ...state, situacoes: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
